const API = process.env.REACT_APP_API || 'http://localhost:3001/api';

function headers() {
  const h = { 'Content-Type': 'application/json' };
  const token = localStorage.getItem('token');
  if (token) h['Authorization'] = `Bearer ${token}`;
  return h;
}

export async function login(email, senha) {
  const res = await fetch(`${API}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, senha }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error);
  localStorage.setItem('token', data.token);
  localStorage.setItem('usuario', JSON.stringify(data.usuario));
  return data;
}

export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('usuario');
}

export function getUsuario() {
  const u = localStorage.getItem('usuario');
  return u ? JSON.parse(u) : null;
}

export function isAuthenticated() {
  return !!localStorage.getItem('token');
}

export async function getProdutos() {
  const res = await fetch(`${API}/produtos`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar produtos');
  return res.json();
}

export async function createProduto(data) {
  const res = await fetch(`${API}/produtos`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Erro ao criar produto');
  return res.json();
}

export async function updateProduto(id, data) {
  const res = await fetch(`${API}/produtos/${id}`, {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Erro ao atualizar produto');
  return res.json();
}

export async function deleteProduto(id) {
  const res = await fetch(`${API}/produtos/${id}`, { method: 'DELETE', headers: headers() });
  if (!res.ok) throw new Error('Erro ao remover produto');
  return res.json();
}

export async function getMovimentacoes() {
  const res = await fetch(`${API}/movimentacoes`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar movimentações');
  return res.json();
}

export async function addEntrada(produto_id, quantidade) {
  const res = await fetch(`${API}/movimentacoes/entrada`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ produto_id, quantidade }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error);
  }
  return res.json();
}

export async function addSaida(produto_id, quantidade, cliente_id) {
  const body = { produto_id, quantidade };
  if (cliente_id) body.cliente_id = cliente_id;
  const res = await fetch(`${API}/movimentacoes/saida`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error);
  }
  return res.json();
}

export async function getResumo(mes, ano) {
  const params = new URLSearchParams();
  if (mes) params.set('mes', mes);
  if (ano) params.set('ano', ano);
  const qs = params.toString();
  const res = await fetch(`${API}/relatorios/resumo${qs ? '?' + qs : ''}`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar resumo');
  return res.json();
}

export async function getRelatorioPeriodo(inicio, fim) {
  const params = new URLSearchParams();
  if (inicio) params.set('inicio', inicio);
  if (fim) params.set('fim', fim);
  const res = await fetch(`${API}/relatorios/periodo?${params}`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar relatório');
  return res.json();
}

export async function getCustos() {
  const res = await fetch(`${API}/custos`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar custos');
  return res.json();
}

export async function createCusto(data) {
  const res = await fetch(`${API}/custos`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Erro ao criar custo');
  return res.json();
}

export async function deleteCusto(id) {
  const res = await fetch(`${API}/custos/${id}`, { method: 'DELETE', headers: headers() });
  if (!res.ok) throw new Error('Erro ao remover custo');
  return res.json();
}

export async function getClientes() {
  const res = await fetch(`${API}/clientes`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar clientes');
  return res.json();
}

export async function createCliente(data) {
  const res = await fetch(`${API}/clientes`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Erro ao criar cliente');
  return res.json();
}

export async function deleteCliente(id) {
  const res = await fetch(`${API}/clientes/${id}`, { method: 'DELETE', headers: headers() });
  if (!res.ok) throw new Error('Erro ao remover cliente');
  return res.json();
}

export async function criarPedido(data) {
  const res = await fetch(`${API}/pedidos`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error);
  }
  return res.json();
}

export async function getPedido(id) {
  const res = await fetch(`${API}/pedidos/${id}`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar pedido');
  return res.json();
}

// ── Insumos ──────────────────────────────────────────────────────────────────
export async function getInsumos() {
  const res = await fetch(`${API}/insumos`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar insumos');
  return res.json();
}

export async function createInsumo(data) {
  const res = await fetch(`${API}/insumos`, { method: 'POST', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function updateInsumo(id, data) {
  const res = await fetch(`${API}/insumos/${id}`, { method: 'PUT', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function deleteInsumo(id) {
  const res = await fetch(`${API}/insumos/${id}`, { method: 'DELETE', headers: headers() });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function entradaInsumo(id, data) {
  const res = await fetch(`${API}/insumos/${id}/entrada`, { method: 'POST', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function getMovimentacoesInsumo(id) {
  const res = await fetch(`${API}/insumos/${id}/movimentacoes`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar movimentações do insumo');
  return res.json();
}

// ── Receitas ──────────────────────────────────────────────────────────────────
export async function getReceitas() {
  const res = await fetch(`${API}/receitas`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar receitas');
  return res.json();
}

export async function getReceita(id) {
  const res = await fetch(`${API}/receitas/${id}`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar receita');
  return res.json();
}

export async function createReceita(data) {
  const res = await fetch(`${API}/receitas`, { method: 'POST', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function updateReceita(id, data) {
  const res = await fetch(`${API}/receitas/${id}`, { method: 'PUT', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function deleteReceita(id) {
  const res = await fetch(`${API}/receitas/${id}`, { method: 'DELETE', headers: headers() });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function getHistoricoReceita(id, inicio, fim) {
  const p = new URLSearchParams();
  if (inicio) p.set('inicio', inicio);
  if (fim) p.set('fim', fim);
  const res = await fetch(`${API}/receitas/${id}/historico?${p}`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar histórico');
  return res.json();
}

// ── Parâmetros de precificação ────────────────────────────────────────────────
export async function getParametros() {
  const res = await fetch(`${API}/parametros`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar parâmetros');
  return res.json();
}

export async function updateParametros(data) {
  const res = await fetch(`${API}/parametros`, { method: 'PUT', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

// ── Categorias de gasto ───────────────────────────────────────────────────────
export async function getCategoriasGasto() {
  const res = await fetch(`${API}/categorias-gasto`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar categorias');
  return res.json();
}

export async function createCategoriaGasto(data) {
  const res = await fetch(`${API}/categorias-gasto`, { method: 'POST', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

// ── Contas fixas ──────────────────────────────────────────────────────────────
export async function getContasFixas() {
  const res = await fetch(`${API}/contas-fixas`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar contas fixas');
  return res.json();
}

export async function createContaFixa(data) {
  const res = await fetch(`${API}/contas-fixas`, { method: 'POST', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function updateContaFixa(id, data) {
  const res = await fetch(`${API}/contas-fixas/${id}`, { method: 'PUT', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function deleteContaFixa(id) {
  const res = await fetch(`${API}/contas-fixas/${id}`, { method: 'DELETE', headers: headers() });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function pagarContaFixa(id, data) {
  const res = await fetch(`${API}/contas-fixas/${id}/pagar`, { method: 'POST', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

// ── Gastos ────────────────────────────────────────────────────────────────────
export async function getGastos(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await fetch(`${API}/gastos${qs ? '?' + qs : ''}`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar gastos');
  return res.json();
}

export async function createGasto(data) {
  const res = await fetch(`${API}/gastos`, { method: 'POST', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function updateGasto(id, data) {
  const res = await fetch(`${API}/gastos/${id}`, { method: 'PUT', headers: headers(), body: JSON.stringify(data) });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

export async function deleteGasto(id) {
  const res = await fetch(`${API}/gastos/${id}`, { method: 'DELETE', headers: headers() });
  if (!res.ok) { const e = await res.json(); throw new Error(e.error); }
  return res.json();
}

// ── Financeiro ────────────────────────────────────────────────────────────────
export async function getFinanceiroMes(competencia) {
  const qs = competencia ? `?competencia=${competencia}` : '';
  const res = await fetch(`${API}/financeiro/mes${qs}`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar resumo financeiro');
  return res.json();
}

export async function getFinanceiroEvolucao(meses = 6) {
  const res = await fetch(`${API}/financeiro/evolucao?meses=${meses}`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar evolução financeira');
  return res.json();
}

export async function getParametrosEfetivos() {
  const res = await fetch(`${API}/financeiro/parametros-efetivos`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar parâmetros efetivos');
  return res.json();
}

export async function getPontoEquilibrio() {
  const res = await fetch(`${API}/financeiro/ponto-equilibrio`, { headers: headers() });
  if (!res.ok) throw new Error('Erro ao buscar ponto de equilíbrio');
  return res.json();
}
